<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-row
            class="flex-child"
        >
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-container fluid>
                        <v-row align="center">
                            <v-col cols="12" md="2" sm="6" xs="3">
                                <el-input v-model="searchData.name" placeholder="请输入姓名"></el-input>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="3">
                                <el-select v-model="searchData.classId" @change="pageChange" filterable
                                           placeholder="选择班级">
                                    <el-option
                                        v-for="item in classItems"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="3">
                                <el-select v-model="searchData.firstClassId" @change="pageChange" filterable
                                           placeholder="选择注册班级">
                                    <el-option
                                        v-for="item in classRegItems"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="3">
                                <el-select v-model="searchData.schoolId" @change="pageChange" filterable
                                           placeholder="选择学校">
                                    <el-option
                                        v-for="item in schoolItems"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </v-col>
                           <!-- <v-col cols="12" md="2" sm="6" xs="3">
                                <el-date-picker
                                    v-model="value2"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </v-col>-->

                            <v-col cols="12" md="3" sm="3" xs="3">
                                <v-row justify="end">
                                    <v-col cols="12" md="1">
                                        <v-btn color="primary" @click="pageChange" dark large>
                                            <v-icon left>mdi-magnify</v-icon>
                                            {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="desserts"
                        item-key="name"
                        class="elevation-1"
                        multi-sort
                        :loading="loading"
                        :footer-props="footerProps"
                        :loading-text="loadingText"
                        :options.sync="options"
                        :server-items-length="totalDesserts"
                        @update:options="changeOptions"

                    >
                        <template v-slot:item.actions="{ item }">
                            <v-btn color="normal" v-5="permissionCode.detail" x-small @click="showDetailDialog(item)" class="ml-2">
                                <v-icon small>
                                    mdi-account-details
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.detail') }}
                            </v-btn>
                            <v-btn class="ml-2" v-5="permissionCode.appraise" color="normal" x-small @click="teacherAppraise(item)">
                                <v-icon small>
                                    mdi-teach
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.outerList.appraise') }}
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>
        </v-row>
        <v-dialog v-model="showDetail" max-width="1000px">
            <score-detail v-model="showDetail" :stuDetailMsg="stuDetailMsg"></score-detail>
        </v-dialog>
        <v-dialog
            v-model="appraiseDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <v-card-title>
                    评价
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                outlined
                                hide-details
                                :label="$vuetify.lang.t('$vuetify.custom.score.appraise')"
                                v-model="appraise"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-file-input accept="image/*" v-model="appraiseFile" label="请选择图像文件"></v-file-input>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error" dark
                        @click="teacherAppraiseCancel"
                    >
                        取消
                    </v-btn>
                    <v-btn
                        color="success" dark @click="appraiseBtn"
                    >
                        评价
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import scoreDetail from '../score/score-detail'

    export default {
        data() {
            return {
                permissionCode:{
                    search:'biz:outer:search',
                    appraise:'biz:outer:appraise',
                    detail:'biz:outer:detail',
                },
                value2:'',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                formData:{
                    fileIds:[],
                    stuId:'',
                    comment:'',
                    recordType:2,
                },
                appraise:'',
                appraiseFile:'',
                appraiseDialog:false,
                showDetail:false,
                stuDetailMsg:{},
                studentDialog: false,
                addDialog: false,
                schoolMsg: {},
                dialog: false,
                loading: true,
                loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
                selected: [],
                footerProps: {
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions:[5,10,20,50],
                    //disableItemsPerPage:true,
                },
                searchData: {
                    name: '',
                    classId: '',
                    schoolId: '',
                    firstClassId:''
                },
                options: {},
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.etoakNo'), value: 'etoakNo',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.name'), value: 'name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.showClassName'), value: 'className',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.firstClassName'), value: 'firstClassName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.schoolName'), value: 'schoolName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.source'),
                        value: 'sourceTypeDesc',
                        sortable: false,
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.changeClassNum'), value: 'transferTimes',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.time'), value: 'hireDate',
                    },
                    {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
                ],
                totalDesserts: 0,
                desserts: [],
                classItems: [
                    {text: '选择隐藏前班级', value: ''},
                ],
                classRegItems: [
                    {text: '选择注册班级', value: ''},
                ],
                schoolItems: [
                    {text: '选择学校', value: ''},
                ],
            }

        },
        mounted(){
            this.initSelect()
        },
        methods: {
            async appraiseBtn() {
                this.formData.fileIds = []
                if (this.appraise == "") {
                    this.$dialog.alert("请填写评论")
                    return
                }
                if (this.appraiseFile != "" && this.appraiseFile != null) {
                    let form = new FormData();
                    form.append("filePath", "recordFiles");
                    form.append('file', this.appraiseFile);
                    let files = await this.$file.fileUpload(form)
                    this.formData.fileIds.push(files.fileId)
                }
                this.formData.comment = this.appraise
                this.$api.studentRecords.addOuterRecords(this.formData).then(data => {
                    if (data.flag) {
                        this.$dialog.alert("评价成功");
                        this.pageChange()
                        this.appraiseDialog = false
                        this.appraise = ''
                        this.appraiseFile = ""
                    } else {
                        this.$dialog.alert(data.msg)
                    }
                })
            },
            teacherAppraiseCancel() {
                this.appraiseDialog = false
                this.appraise = ''
                this.formData.stuId = ''
                this.formData.comment = ''
                this.appraiseFile = ""
                this.formData.recordType = 2
                this.formData.fileIds = []
            },
            teacherAppraise(item) {
                this.appraiseDialog = true
                this.formData.stuId = item.id
                this.formData.recordType = 2
            },
            pageChange(){
                this.options.page = 1
                this.initialize()
            },
            showDetailDialog(item) {
                this.showDetail = true;
                this.stuDetailMsg.studentId = item.id
            },
            initSchoolItems() {
                this.$api.school.getSchoolSelect().then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.schoolItems.push({text: obj.schoolName, value: obj.id})
                        })
                    }
                })
            },
            initClassItems() {
                this.$api.classList.getAllClass().then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.classItems.push({text: obj.className, value: obj.id})
                            if(obj.className != "长假人群"){
                                this.classRegItems.push({text: obj.className, value: obj.id})
                            }
                        })
                    }
                })
            },
            initSelect() {
                this.initClassItems()
                this.initSchoolItems()
            },
            initialize() {
                this.loading = true
                this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
                this.$api.student.outer(
                    Object.assign({atWb:1}, this.searchData, this.options)
                ).then(data => {
                    this.loading = false;
                    if (data.data) {
                        this.desserts = data.data;
                        this.totalDesserts = data.total;
                    } else {
                        this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                    }

                })

            },
            changeOptions(option) {
                this.initialize()
            }
        },
        components: {
            scoreDetail
        },
    }
</script>
<style></style>
